export default __webpack_public_path__ + "static/media/22_1_2.0b001eca.png";